import { useQuery } from '@tanstack/react-query';
import { globalSearch } from '../api/searchApi';

export function useGlobalSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    queryFn: () => globalSearch(query),
    enabled: query.trim().length >= 2,
    staleTime: 30000,
  });
}
